import { useRef, useState, useEffect } from "react";

const MyCollapseContent = (props) => {
  const { openItem, item } = props;

  const contentRef = useRef();
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      if (contentRef.current) {
        setContentHeight(contentRef.current.scrollHeight);
      }
    };

    const resizeObserver = new ResizeObserver(updateHeight);
    if (contentRef.current) {
      resizeObserver.observe(contentRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div
      ref={contentRef}
      style={{
        maxHeight: openItem === item.value ? `${contentHeight}px` : "0px",
        transition: "max-height 0.3s ease",
        overflow: "hidden",
      }}
    >
      {item.content()}
    </div>
  );
};

export default MyCollapseContent;
